<template>
  <div>
    <vs-card>
      <div slot="header">
        <h4>Toutes mes évaluations</h4>
      </div>
      <div v-for="(item, key) in evaluations" :key="key">
        <div class="flex">
          <div class="w-1/5 bg-grid-color h-12">
            <feather-icon icon="AwardIcon" />
          </div>
          <div class="w-3/5 bg-grid-color-secondary h-12">
            <h5>{{ item.name }}</h5>
            <p style="font-size: 14px">
              TTC Évaluation passée le {{ item.passer_le }}
            </p>
            <p>
              <a
                style="font-size: 14px; cursor: pointer"
                @click.prevent="
                  $router.push({
                    name: 'evaluation_resultats_detail',
                    params: {
                      id: item.result_id,
                      slug: item.evaluation_slug,
                    },
                  })
                "
                >Voir les détails</a
              >
              <a
                v-if="item.success == '1'"
                @click="dowloadEvaluationCertificate(item.slug_result)"
                style="font-size: 14px; cursor: pointer"
                class="ml-4"
                >Télécharger le certificat</a
              >
            </p>
          </div>
          <div class="w-1/5 bg-grid-color h-12">
            <vs-row><h4>Note</h4></vs-row>
            <vs-row
              ><h6>{{ item.marks_obtained + " %" }}</h6></vs-row
            >
          </div>
        </div>
        <vs-divider />
      </div>
    </vs-card>
    <vs-row>
      <vs-col>
        <vs-pagination
          v-if="last_page && page"
          :total="last_page"
          v-model="page"
        ></vs-pagination>
      </vs-col>
    </vs-row>
  </div>
</template>
<script>
export default {
  data: () => ({
    evaluations: [],
    page: 1,
    last_page: null,
  }),
  watch: {
    page(value) {
      this.loadEvaluation(value);
    },
  },
  methods: {
    perc(mark, total) {
      return Math.round((mark / total) * 100);
    },
    loadEvaluation(page) {
      this.$vs.loading();
      this.$http
        .get("/evaluation/mes-evaluations?page=" + page)
        .then((response) => {
          this.evaluations = response.data.data;
          this.last_page = response.data.last_page;
          this.$vs.loading.close();
        })
        .catch((error) => {
          this.$vs.loading.close();
          console.log(error);
        });
    },
    async dowloadEvaluationCertificate(quizz_result_slug) {
      try {
        this.$vs.loading();
        let response = await this.$http({
          url: "/evaluation/download-certificate",
          method: "POST",
          responseType: "blob",
          data: {
            result: quizz_result_slug,
          },
        });

        if (response.data) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "certificate.pdf");
          document.body.appendChild(link);
          link.click();

          this.$vs.loading.close();
        }
      } catch (error) {
        this.$vs.loading.close();
        if (error.response.status === 401) {
          this.$vs.notify({
            title: "Erreur",
            text: "Votre session a expiré",
            color: "danger",
            iconPack: "feather",
            icon: "icon-check",
            position: "top-right",
          });
          this.$router.push({ name: "login" });
        }
      }
    },
  },
  mounted() {
    this.loadEvaluation(this.page);
  },
};
</script>

<style scoped>
svg {
  width: 50px !important;
  height: 50px !important;
}
</style>